/* const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8082';

export async function fetchWithAuth(url, options = {}) {
  let accessToken = localStorage.getItem('accessToken');

  options.headers = {
    ...options.headers,
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };
  options.credentials = 'include'; // Envia cookies (ex: refreshToken)

  let response = await fetch(API_BASE + url, options);

  if (response.status === 401) {
    const refreshResponse = await fetch(API_BASE + '/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    });

    if (refreshResponse.ok) {
      const data = await refreshResponse.json();
      accessToken = data.accessToken;
      localStorage.setItem('accessToken', accessToken);

      options.headers.Authorization = `Bearer ${accessToken}`;
      response = await fetch(API_BASE + url, options);
      return response;
    } else {
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
      return;
    }
  }

  return response;
} */

/*
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8082';

export async function fetchWithAuth(url, options = {}) {
  let accessToken = localStorage.getItem('accessToken');
  console.log('Token antes da requisição:', accessToken);

  options.headers = {
    ...options.headers,
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };

  console.log('Headers enviados:', options.headers);

  options.credentials = 'include';

  let response = await fetch(API_BASE + url, options);

  if (response.status === 401) {
    console.warn('Token expirado. Tentando renovar...');

    const refreshResponse = await fetch(API_BASE + '/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    });

    if (refreshResponse.ok) {
      const data = await refreshResponse.json();
      accessToken = data.accessToken;

      if (!accessToken) {
        console.error('A resposta de /refresh não retornou accessToken');
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
        return;
      }

      localStorage.setItem('accessToken', accessToken);

      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      };

      response = await fetch(API_BASE + url, options);
      return response;
    } else {
      console.error('Erro ao renovar token. Redirecionando para login...');
      localStorage.removeItem('accessToken');
      window.location.href = '/login';
      return;
    }
  }

  return response;
} */



import { handleError, ErrorTypes } from './errorHandler';

// Esta função ajuda a obter o contexto mesmo fora de componentes React
let authContextRef = null;
export const setAuthContext = (context) => {
  authContextRef = context;
};

export const fetchWithAuth = async (url, options = {}) => {
  const token = authContextRef?.token || localStorage.getItem('accessToken');

  const authOptions = {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : '',
    },
    credentials: 'include', // 🔁 necessário para enviar cookie httpOnly
  };

  try {
    let response = await fetch(url, authOptions);

    if (response.status === 401) {
      const newToken = await renewToken();

      if (newToken) {
        // Atualiza token no AuthContext e repete a requisição
        localStorage.setItem('accessToken', newToken);
        authContextRef?.login?.(newToken); // atualiza o estado global

        authOptions.headers.Authorization = `Bearer ${newToken}`;
        response = await fetch(url, authOptions); // 🔁 tenta novamente
      } else {
        handleError(
          { message: 'Sessão expirada', type: ErrorTypes.AUTH },
          { context: 'fetchWithAuth', customMessage: 'Sua sessão expirou. Por favor, faça login novamente.' }
        );
        throw new Error('Sessão expirada');
      }
    }

    // Se o backend retornar erro com mensagem, exibir
    if (!response.ok) {
      const errorMessage = await handleApiError(response, {
        context: 'fetchWithAuth',
      });
      throw new Error(errorMessage || 'Erro ao processar a requisição');
    }

    return response;
  } catch (error) {
    // Se já foi tratado pelo handleApiError, não trata novamente
    if (error.message && !error.message.includes('Erro ao processar')) {
      handleError(error, { context: 'fetchWithAuth' });
    }
    throw error;
  }
};

/**
 * Trata erros de API
 */
const handleApiError = async (response, options = {}) => {
  if (response.ok) return null;

  let errorData;
  try {
    errorData = await response.json();
  } catch {
    errorData = { message: 'Erro ao processar resposta do servidor' };
  }

  const error = {
    message: errorData.message || errorData.error || 'Erro ao processar requisição',
    code: response.status,
    status: response.status,
  };

  return handleError(error, {
    ...options,
    context: options.context || 'API',
  });
};

const renewToken = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BACKEND_URL || '';
    const response = await fetch(`${apiUrl}/api/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    return data.accessToken;
  } catch (err) {
    return null;
  }
};

